import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'
import { MonetizationButton } from '@jelly/components'
import { generateMarketingIdUrl } from '.'
import { useLocation } from '@reach/router'

const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
	box-shadow: 0 5px 31px 0 rgba(0, 59, 92, 0.08);
	display: flex;
	flex-direction: column;
	margin: 0 auto 3rem;
	max-width: 356px;
	width: 100%;
`
const TopBar = styled.div`
	${({ theme }) => theme.fonts.primarySemiBold};
	align-items: center;
	background-color: ${({ isFirstCard, theme }) => (isFirstCard ? `${theme.colors.primary}` : theme.colors.gray[200])};
	color: ${({ theme }) => theme.colors.white};
	display: flex;
	font-size: 1rem;
	height: 2.25rem;
	justify-content: center;
	letter-spacing: 3.4px;
	line-height: 25px;
	text-align: center;
	width: 100%;
`
const CardTitle = styled.p`
	display: none;

	${({ theme }) => theme.MQ.M} {
		${({ theme }) => theme.fonts.primaryMedium};
		color: ${({ theme }) => theme.colors.primary};
		display: flex;
		font-size: 1.125rem;
		letter-spacing: 0;
		line-height: 27px;
		margin: 0.25rem 0 0.5rem;
	}
`
const MainContent = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	height: auto;
	justify-content: center;
	padding: 1rem;
	width: 100%;
`
const ServiceImage = styled.img`
	margin: 0 0 0.25rem;
	max-width: 125px;
	width: 100%;
`

const ButtonWrapper = styled.div`
	margin-top: 10px;
`

SimpleCard.propTypes = {
	service: object,
}

/**
 * Detailed Card that consists of a card title, rating, bullets, and offer buttons
 * @param {Object} props.service - service data
 *
 */
export function SimpleCard({ service }) {
	const { id, name, image, cardTitle, url, rfqCatId } = service
	const isFirstCard = id === '1'
	const [marketingIdUrl, setMarketingIdUrl] = useState(url)
	const { search } = useLocation()

	useEffect(() => {
		// replace marketingId with the query marketingId value
		setMarketingIdUrl(generateMarketingIdUrl(search, url))
	}, [search, url])

	return (
		<Wrapper isFirstCard={isFirstCard} className="embla__slide">
			<TopBar isFirstCard={isFirstCard}>{isFirstCard ? 'OUR BEST OVERALL' : ''}</TopBar>

			<MainContent>
				<ServiceImage src={image} alt={name} />
				<CardTitle>{cardTitle}</CardTitle>
				<ButtonWrapper>
					<MonetizationButton
						pricing={{
							affiliate: marketingIdUrl
								? {
										cta: 'Visit Site',
										link: marketingIdUrl,
										name: 'QT Program',
										isAddQtParams: false,
								  }
								: undefined,
							isFeatured: false,
							primary: true,
							selected: 'affiliate',
							widget: {
								cta: 'Compare Quotes',
								id: rfqCatId,
								isExclusive: false,
							},
							widgetId: rfqCatId,
						}}
						rank={id}
						sectionType="simpleCard"
						serviceName={name}
						templateType="top5landingpage"
						type="top5card"
					/>
				</ButtonWrapper>
			</MainContent>
		</Wrapper>
	)
}
